import { extractStyles } from './tools';
import CarbonVars from './CarbonVars';
import GlobalStyles from './GlobalStyles';
import styles from '../carbon/carbon.css';
import Logo from './brand/images/logo.svg';
import { fontMap } from './brand/specs';

const BrandVars = {
  name: 'Castrol',
  version: '0.2',

  // *  Type scale
  //   *
  //       *  We use a 1rem = 16px baseline for setting font- size and line-height
  // *
  //       * Baseline body copy font is 16px / 24px = 1rem / 1.5rem

  // *
  //       * Usage:
  //       * font: 400 ${ props => props.theme.type.type0 } ${ props => props.theme.font.default }

  type: {
    type_4: '0.6rem/1rem',
    type_3: '0.75rem/1.25rem',
    type_2: '0.8125rem/1.4375rem',
    type_1: '0.875rem/1.25rem',
    type0: '1rem/1.5rem',
    type1: '1.125rem/2rem',
    type2: '1.25rem/1.875rem',
    type3: '1.4375rem/2.1875rem',
    type4: '1.625rem/2.375rem',
    type5: '1.8125rem/2.375rem',
    type6: '2rem/3rem',
    type7: '3rem/4rem',
    type8: '5.625rem/8.4375rem'
  },

  font: {
    default: `${fontMap.base.name}, Roboto`,
    light: `${fontMap.baseLight.name}, Roboto-Light`,
    heading: `${fontMap.heading.name}, Roboto`,
    condensed: `${fontMap.heading.name}, RobotoCondensed`,
    castrol: `${fontMap.castrol.name}, CastrolSanscon`
  },

  easing: {
    ease_inOut: 'cubic-bezier(0.645, 0.045, 0.355, 1)',
    ease_outQuint: 'cubic-bezier(0.23, 1, 0.32, 1)'
  },

  // Components

  fontStylePrimary: fontMap.base.name,
  fontStyleHeading: fontMap.heading.name,

  atoms: {
    button: {
      radius: '1.4375rem'
    }
  },

  organisms: {
    header: { logoWidth: '7rem', logoHeight: '1.625rem' },
    welcome: {
      maskColor: 'rgba(0,147,67,0.5)',
      behindMaskColor: 'rgba(17, 17, 17)'
    }
  },

  static: {
    logo: './brand/images/brand-12.svg',
    tempImg:
      'https://www.castrol.com/content/dam/castrol/shared/About-Us/News-Events-Alerts/News-Events-Articles/Story%201%2C%20Picture%201.jpg',
    Logo
  },

  /* This is needed for the storybook */
  GlobalStyles,
  styles: extractStyles(styles)
};

const Theme = Object.assign(CarbonVars, BrandVars);

export default Theme;
